//判断是否滚动到底部
function isScrollEnd($dom) {
  const $win = $(window);
  const windowHeight = $win.height();
  const domHeight = $dom.height();
  const domTop = $dom.offset().top;
  const scrollTop = $win.scrollTop();
  if (scrollTop + windowHeight > domHeight + domTop) {
    return true;
  }
  return false;
}
//加载下一页数据
let isLoading = false;
let currentPage, totalPage;
function loadNextPage($dom) {
  isLoading = true;
  currentPage = $dom.data('page') || 1;
  const loadPage = currentPage + 1;
  const cardId = $dom.attr('data-cardId');
  const organizationId = $dom.attr('data-organizationId');
  $.ajaxSync.get('/information/load/list', {page: loadPage, cardId, organizationId}).then(({res}) => {
    isLoading = false;
    $dom.data('page', loadPage);
    const listData = res.data.results.list ? res.data.results.list : [];
    totalPage = res.data.results.pagination.totalPage;
    listData.map((list) => {
      var imgList = list.titleImageUrl ? '<a href="/information/' + list.publishInformationId + '"><img src="' + fileDomain + list.titleImageUrl + '"/></a>' : '';

      var htmlText = '<div class="information-item">' +
                          '<div class="information-title">' + list.title + '</div>' +
                          '<div class="information-images">' +
                              imgList +
                          '</div>' +
                          '<div class="information-short-info">' +
                              '<div class="create-time"><i class="s3-icon-clock"></i>&nbsp;&nbsp;发布时间：' + list.publishDatetime + '</div>' +
                              '<div class="view-count"><i class="s3-icon-eye"></i>&nbsp;&nbsp;' + list.clickNumber + '</div>' +
                          '</div>' +
                      '</div>';
      $dom.append(htmlText);
    })
  });
}
const init = () => {
  const $wrap = $('.information-list.scroll-loading');
  if ($wrap.length) {
    $(window).on('scroll', () => {
      $wrap.each(function () {
        if (!isLoading && isScrollEnd($(this))) {
          if (!totalPage || totalPage > currentPage) {
            loadNextPage($(this));
          }
        }
      });
    });
  }
};
module.exports = {init};